import React from 'react';
import HeroSection from '../components/common/HeroSection';
import ActivitiesOfChaitralee from '../components/chaitralee/ActivitiesOfChaitralee';

const breadcrumb = [
  { key: 'nav.home',                  path: '/' },
  { key: 'nav.chaitraleeActivities',  path: null },
];

const ChaitraleeActivities = () => (
  <>
    <HeroSection
      titleKey="chaitraleeAct.title"
      subtitleKey="chaitraleeAct.subtitle"
      breadcrumbItems={breadcrumb}
    />
    <ActivitiesOfChaitralee />
  </>
);

export default ChaitraleeActivities;
